const isProduction = import.meta.env.NODE_ENV === 'production';
import { LogLevels } from 'vuejs3-logger/dist/enum/log-levels';

export const loggingOptions = {
    isEnabled: true,
    logLevel: isProduction ? LogLevels.ERROR : LogLevels.DEBUG,
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};
